export default __webpack_public_path__ + "static/graceCardMockup-56aaf56b7cc939d8e4a5cff5dd317e3b.png";